import { createSchema, morphism } from 'morphism';

const addressSchema = createSchema(
  {
    state: 'state',
    city: 'city',
    type: 'type',
    zipcode: 'zipcode',
    country: 'country'
  },
  { undefinedValues: { strip: true } }
);

const historySchema = createSchema(
  {
    action: 'action',
    timestamp: 'timestamp'
  },
  { undefinedValues: { strip: true } }
);

const updateContactSchema = createSchema(
  {
    anniversary: source => {
      if (!source?.anniversary?.split) {
        return;
      }
      const [month, day, year] = source.anniversary.split('/');
      return {
        month: month || null,
        day: day || null,
        year: year || null
      };
    },
    birthday: source => {
      if (!source?.birthday?.split) {
        return;
      }
      const [month, day, year] = source.birthday.split('/');
      return {
        month: month || null,
        day: day || null,
        year: year || null
      };
    },
    company: 'company',
    department: 'department',
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    phone: 'phone',
    relation: 'relation',
    deleted: 'deleted',
    addresses: source => morphism(addressSchema, source.addresses),
    tags: source => source?.tags?.map(item => item.id || item.value),
    history: source => morphism(historySchema, source.history)
  },
  { undefinedValues: { strip: true } }
);

const contactSchema = createSchema(
  {
    anniversary: source => {
      if (!source?.anniversary?.split) {
        return;
      }
      const [month, day, year] = source.anniversary.split('/');
      return {
        month: month || null,
        day: day || null,
        year: year || null
      };
    },
    birthday: source => {
      if (!source?.birthday?.split) {
        return;
      }
      const [month, day, year] = source.birthday.split('/');
      return {
        month: month || null,
        day: day || null,
        year: year || null
      };
    },
    company: 'company',
    department: source => (source.department === '' ? source.department : undefined),
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    phone: 'phone',
    relation: 'relation',
    deleted: 'deleted',
    addresses: source => morphism(addressSchema, source.addresses),
    history: source => morphism(historySchema, source.history),
    tags: source =>
      source?.tags?.length > 0 ? source.tags.map(item => item.id || item.value || item) : undefined
  },
  { undefinedValues: { strip: true } }
);

export default {
  update: createSchema(updateContactSchema, { undefinedValues: { strip: true } }),
  bulkUpsert: createSchema(
    {
      tags: source =>
        source.tags?.length > 0 ? source.tags?.map(item => item.id || item) : undefined,
      contacts: source => morphism(contactSchema, source.contacts)
    },
    { undefinedValues: { strip: true } }
  ),
  bulkUpdate: createSchema(
    {
      contacts: source =>
        source.contacts.map(contact => ({
          id: contact,
          tags: source.tags?.length > 0 ? source.tags?.map(item => item.id) : undefined
        }))
    },
    { undefinedValues: { strip: true } }
  ),
  listContact: createSchema(
    {
      filters: {
        searchTerm: 'filters.searchTerm',
        email: 'filters.email',
        ids: source => source?.filters?.ids?.join(',') || undefined,
        tags: 'filters.tags',
        birthday: 'filters.birthday',
        anniversary: 'filters.anniversary'
      },
      options: 'options',
      pagination: 'pagination'
    },
    { undefinedValues: { strip: true } }
  )
};
